<template>
  <div v-if="isOpen" class="modal fade show d-block d-flex align-items-center justify-content-center" tabindex="-1">
    <div @click="$emit('close')" class="h-100 w-100 position-fixed z-1 modal-overlay"></div>
    <div class="modal-dialog z-2 p-2 d-flex align-items-center justify-content-center">
      <div class="modal-content p-2 custom-scroll">
        <div class="d-flex justify-content-between align-items-center">
          <h2 class="modal-title flex-grow-1 text-center mt-2">Confirmación TPV</h2>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>
        <div class="mt-4 p-4">
          <p>Has seleccionado un TPV. Los platos, mesas y categorías configurados en la plataforma se van a desactivar para usar la información del TPV. Estos datos se desactivarán, pero no se eliminarán.</p>
        </div>
        <div class="modal-footer align-items-center justify-content-center border-none">
          <button type="button" class="btn btn-add text-white px-4 rounded-3" style="background-color: var(--primary-color)" @click="$emit('confirm')">Aceptar</button>
          <button type="button" class="btn btn-danger px-4 rounded-3" @click="$emit('close')">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TpvConfirmationModal',
  props: {
    isOpen: { type: Boolean, required: true }
  },
};
</script>

<style scoped>
  .modal { 
    background-color: rgba(139, 139, 139, 0.5); 
  }

  @media (min-width: 767px) {
    .modal-dialog {
      position: absolute;
      width: 80%;
      left: 28%;
      min-width: 60%; 
    }
  }

  @media (max-width: 576px) {
    .modal-dialog {
      max-width: 90%;
      margin: 0 auto;
    }
  }
</style>
